import { CardElement } from '@stripe/react-stripe-js';
import React from 'react';

import styles from './CardSection.module.scss';
import './CardSection.scss';

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: '#32325d',
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '16px',
      '::placeholder': {
        color: '#aab7c4',
      },
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a',
    },
  },
};

type CardSectionProps = {
  cardValidation: (e: any) => void;
};

const CardSection: React.FC<CardSectionProps> = (props) => {
  return (
    <label>
      <span className={styles.cardLabel}>Card Details</span>
      <CardElement
        className={styles.cardElement}
        options={CARD_ELEMENT_OPTIONS}
        onChange={(e) => props.cardValidation(e)}
      />
    </label>
  );
};

export default CardSection;
